var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _path14, _mask, _mask2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMileMarkerHeroComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 329.05347,
    viewBox: "0 0 531 329.05347",
    fill: "none",
    id: "svg169",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_7098)",
    id: "g37",
    transform: "translate(-246,-306.98953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 744.698,524.552 10.526,-4.369 2.12,-1.39 -2,-3.5 -2.5,-3.5 -5.5,-5.5 -5.5,-10.5 -8,-18.5 -6.824,-15.395 c 0,0 -9.08,-8.681 -18.275,-8.758 -9.196,-0.077 -22.517,1.367 -22.517,1.367 l -8.058,-7.142 -5.326,-1.072 1,9.5 v 3.5 l -14,16 -10.764,8.683 -14.728,-22.636 8.992,-2.047 -2,-8.5 -6.992,3 -7.008,8.144 -4.212,1.828 -16.788,3.528 c 0,0 -12.017,8.476 -13,13.5 -6,10 -7.25,20.744 -7.5,27 -0.251,6.256 -2.945,17.5 -2.945,17.5 l -0.555,5 17.5,2 c 6.795,18.635 5.942,36.787 18,54.5 0,0 -17.823,10 -27.5,31.5 l -4.5,17 h 150.777 l -1.277,-16.5 c 0,0 -8.671,-39.036 -21.703,-47.832 l -4.896,-3.465 5.147,-20.5 -1.889,-6.198 32.695,-16.169 z",
    fill: "#006ef5",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 710.113,541.913 13.731,-9.122 28.603,-12.244 3.123,8.681 15.172,36.649 c 0,0 2.487,2.791 1.658,10.183 -0.829,7.391 -4.646,10.548 -4.646,10.548 0,0 -11.104,9.085 -13.61,10.279 -2.506,1.193 -25.697,9.068 -25.697,9.068 -35.614,11.089 -51.184,12.966 -73.218,11.349 l -13.417,8.258 -5.968,1.729 -21.5,1 -1.5,-1.5 1.5,-4 13.742,-13.494 -7.653,-2.368 -0.983,-3.195 2.294,-1.81 15.287,-2.81 c 0,0 6.593,-5.178 8.386,-5.178 1.793,0 34.715,-8.443 41.906,-10.484 19.711,-5.593 35.706,-16.535 35.706,-16.535 l -7.055,-16.111 -5.13,-9.262 z",
    fill: "#f4f1fa",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 599.921,532.022 -11.577,-1.229 -3.595,47 -77.405,-29.5 v 33 l 81,40.5 c 0,0 11.153,-23.589 29.5,-35 -13,-34 -17.923,-54.771 -17.923,-54.771 z",
    fill: "#f4f1fa",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 647.844,483.793 14.5,-11 14.283,-17.477 -3.065,0.231 -4.916,-37.092 c 0,0 14.227,-12.877 17.639,-21.212 3.412,-8.335 5.899,-16.554 4.222,-20.288 -1.677,-3.734 -3.239,-6.872 -7.287,-7.815 -4.049,-0.943 -9.909,-0.212 -9.909,-0.212 l -6.072,4.37 -5.302,-10.625 -4.53,-9.663 c 0,0 -27.066,0.211 -39.365,-4.928 -12.3,-5.139 -18.758,-9.393 -18.758,-9.393 l -3.855,-4.966 c 0,0 -3.412,3.676 -4.492,7.064 -1.08,3.388 -4.839,17.266 -4.839,17.266 l -0.25,12.877 1.652,14.57 c 0,0 2.595,14.302 3,20 0.405,5.698 3.571,15.67 6,19 2.429,3.33 5.5,7.5 5.5,7.5 l 6,3.5 7,1.5 c 10.458,-0.53 12.836,0.146 21.702,-3.185 l 5.842,25.447 -9.157,1.983 14.053,20.846 z",
    fill: "#f4f1fa",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 672.715,378.415 c 0,0 9.234,-9.298 11.412,4.754",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 588.549,388.888 c 0.032,0.986 -11.726,-7.779 -15.866,-16.9 -4.125,-8.104 -3.586,-15.245 -3.586,-15.245 0,0 0.887,-19.672 9.427,-26.101 8.54,-6.429 15.365,-9.086 15.365,-9.086 l 6.824,-1.308 c 0,0 13.976,-7.373 21.379,-8.97 7.403,-1.598 29.322,-5.101 45.669,-2.753 16.348,2.349 25.428,4.042 34.083,10.548 8.656,6.506 10.854,14.687 11.413,21.482 0.559,6.795 1.022,15.861 0,18.652 -1.022,2.791 -0.482,6.814 -0.482,6.814 l -0.015,2.783 c -0.102,19.739 16.79,33.937 30.941,47.699 2.137,2.078 3.833,4.444 4.815,7.129 7.807,15.711 7.239,30.492 5.629,32.145 -0.308,1.655 -6.901,16.381 -6.901,16.381 l -7.962,6.891 -3.91,1.958 c 0,0 -3.973,-10.973 -7.372,-16.507 -3.836,-5.043 -9.52,-9.691 -17,-11 -7.48,-1.309 -25.715,1.026 -25.715,1.026 l -4.608,-4.081 -3.45,-3.06 -4.878,-1.059 -3.682,-27.834 c 0,0 12.261,-12.992 14.536,-16.399 3.546,-3.421 9.529,-19.938 7.865,-23.618 -0.54,-3.658 -1.966,-6.641 -4.896,-7.969 -2.931,-1.328 -10.642,-1.733 -10.642,-1.733 l -5.918,3.619 -2.352,0.962 -9.832,-20.288 c 0,0 -26.256,-1.924 -34.873,-3.561 -8.617,-1.636 -14.304,-4.869 -14.304,-4.869 l -11.702,-8.605 -3.084,-2.252 c 0,0 -7.577,16.208 -7.442,20.269 0.135,4.062 -0.135,16.958 -0.135,16.958 l 2.699,17.959 z",
    fill: "#ffffff",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 615,437.5 10,-0.5 11.5,-3 19,-8.5 c 0.239,-0.119 0.522,-0.265 0.846,-0.435 l -5.34,3.166 20.494,13.269 -3.254,-23.489 -0.184,0.109 c 1.268,-0.82 2.587,-1.695 3.938,-2.62 7.6,-5.2 15.167,-19.833 18,-26.5 l 1,-7 -1,-8 -6.5,-5 c 1.333,4.868 0.6,18.884 -13,36 -13.6,17.116 -42,28.298 -55.5,32.5 z",
    fill: "#222838",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 752.197,521.048 c 9.331,22.598 17.832,43.386 17.832,43.386 0,0 13.899,23.002 -25.639,36.438 -39.255,13.339 -70.281,19.368 -88.628,16.477 -0.259,-0.04 -0.518,0.021 -0.732,0.17 -6.473,4.521 -12.148,8.411 -18.326,9.622 -5.86,1.148 -22.844,2.617 -23.712,0 -0.867,-2.618 5.051,-7.661 5.051,-7.661 l 16.016,-16.32 c 0.597,-0.608 1.022,-1.364 1.402,-2.127 1.098,-2.205 4.336,-6.762 12.598,-7.674 10.988,-1.212 50.758,-12.102 66.277,-21.322 3.605,-2.305 5.739,-3.68 6.948,-4.464 0.82,-0.532 1.125,-1.579 0.725,-2.47 l -10.931,-24.364",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 615.789,464.937 c -4.604,-5.692 -3.793,-19.65 -2.811,-25.918 5.597,0 18.373,-3.395 24.061,-5.092 l 3.923,17.431 c -8.474,1.88 -12.554,8.313 -13.535,11.294 z",
    fill: "#ffffff",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 730.157,468.356 c 1.773,4.177 7.773,18.335 10.028,23.744",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 655.363,425.576 c 0,0 -20.622,12.693 -40.363,11.423 -27.52,-1.771 -25.919,-46.037 -28.535,-64.684 -3.355,-23.907 7.981,-38.593 7.981,-38.593 0,0 12.029,19.883 63.655,19.268 3.836,8.969 8.598,21 8.598,21 6.728,-9.22 18.911,-6.295 22.69,0 3.778,6.294 0,20.981 -6.304,27.679 -2.525,6.718 -14.439,16.785 -14.439,16.785 l 4.916,37.092",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 604.952,382.384 c 0,0 -6.728,10.664 -4.626,12.338 2.101,1.675 6.728,6.294 6.728,6.294",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 612.71,408.446 c 0,0 6.903,0 8.641,-7.34",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 636.704,599.077 c 0,0 -11.451,2.464 -15.229,3.041 -3.778,0.578 -1.369,3.985 0,4.755 1.369,0.77 4.222,1.597 7.557,1.424",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 636.704,433.853 5.615,24.46 c 0.124,0.543 -0.218,1.083 -0.762,1.201 l -8.13,1.768",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 712.926,546.919 -4.796,19.173 c -0.2,0.8 0.111,1.641 0.784,2.117 l 5.4,3.829",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 735.463,480.781 c 0,0 22.459,-6.468 18.97,-40.115 -1.107,-10.671 -5.79,-18.361 -11.669,-23.887 -14.2,-13.346 -30.858,-28.58 -30.858,-48.068 v 0 c 0,-3.635 0.557,-7.239 1.134,-10.829 1.967,-12.231 2.929,-41.646 -31.612,-47.529 -43.857,-7.468 -70.326,2.676 -81.488,10.414 -13.031,0 -31.364,12.011 -30.825,35.514 0.442,19.923 14.219,29.885 18.385,32.447",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 612.896,439.05 c 0,0 -2.988,17.67 2.814,26.062",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 672.329,446.267 c 0,0 12.993,-2.079 0,14.764 -10.095,13.085 -19.119,19.664 -22.643,21.948 -0.874,0.566 -2.007,0.285 -2.575,-0.588 L 633.388,461.3 c 0,0 -4.55,-7.372 5.089,-9.201",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 677.206,447.346 6.901,7.141 2.796,-0.27 12.742,-1.27 c 0,0 22.594,-2.599 30.421,15.187",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 632.309,473.139 c 0,0 4.132,7.166 14.787,18.99 0.6,0.667 1.58,0.845 2.372,0.423 21.33,-11.373 31.189,-30.673 31.189,-30.673 0.976,-1.716 3.029,-5.553 3.436,-7.183",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 633.445,454.487 c 0,0 -3.337,2.746 -6.381,8.162 l -17.253,3.734 c 0,0 -21.765,3.811 -23.982,43.56 m 2.015,110.849 -80.553,-39.257 v -33.762 l 74.952,29.06 c 1.239,0.48 2.591,-0.355 2.702,-1.679 0.506,-6.025 1.767,-21.981 2.899,-43.862",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 740.128,491.991 c 1.927,4.095 4.588,13.531 12.05,19.394 3.268,2.568 4.472,5.471 4.88,6.82 0.134,0.443 -0.102,0.883 -0.531,1.058 -4.817,1.969 -32.287,13.239 -36.312,15.837 -3.738,2.412 -10.047,6.177 -11.893,7.274 -0.321,0.191 -0.719,0.183 -1.003,-0.06 -1.044,-0.892 -3.528,-3.514 -4.84,-9.12 -0.963,-4.119 -3.2,-13.897 -4.086,-15.668",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 748.44,515.947 c 0,0 -33.218,11.511 -38.596,17.844",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 585.848,509.941 c 0,0 -1.594,11.18 -3.628,19.091 -0.142,0.551 0.194,1.111 0.75,1.226 7.441,1.533 16.97,1.762 16.97,1.762",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 598.092,525.335 c 0,0 -6.962,0.048 -8.852,-0.818",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 603.488,491.155 c 0,0 -7.769,23.599 -3.567,40.865 3.703,15.212 14.793,46.134 17.38,53.277 0.319,0.882 -0.012,1.855 -0.778,2.396 -5.748,4.06 -28.388,21.57 -30.675,46.922 m 145.528,-29.701 c 4.691,12.962 5.352,22.574 5.262,29.701",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 652.937,514.35 h 26.198 v 17.67 H 652.937 V 519.2",
    fill: "#ffffff",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 652.937,514.35 h 26.198 v 17.67 H 652.937 V 519.2",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 657.793,519.778 c 0,0 10.796,-0.77 14.921,0",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 657.793,525.726 c 0,0 8.058,-0.462 11.143,0",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 619.348,383.881 c 0.632,0 1.144,-1.54 1.144,-3.439 0,-1.899 -0.512,-3.439 -1.144,-3.439 -0.632,0 -1.145,1.54 -1.145,3.439 0,1.899 0.513,3.439 1.145,3.439 z",
    fill: "#222838",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 593.903,385.697 c 0.632,0 1.144,-1.539 1.144,-3.439 0,-1.899 -0.512,-3.439 -1.144,-3.439 -0.633,0 -1.145,1.54 -1.145,3.439 0,1.9 0.512,3.439 1.145,3.439 z",
    fill: "#222838",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 616.692,365.098 c 5.37,-3.497 12.308,-2.843 18.152,3.836",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 593.818,365.101 c -4.852,-0.878 -8.319,1.656 -9.002,6.386",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 637.346,608.882 C 633.21,614.388 623.615,625.4 618.321,625.4",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 640.655,615.489 c -3.129,4.166 -6.542,8.647 -10.311,10.582",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path37"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 258.068,115.36547 H 0 l 41.387,160.029 c 1.011,3.909 4.537,6.64 8.575,6.64 h 75.039 44.541 135.059 l -42.245,-163.349 c -0.506,-1.954 -2.269,-3.32 -4.288,-3.32 z",
    fill: "#e6eaf5",
    id: "path38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 95.343,281.53347 32.5,-45.386 -2.063,45.386 z",
    fill: "#dadfeb",
    id: "path39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 263.468,106.02147 H 13.008 c -2.349,0 -4.602,0.933 -6.263,2.594 L 0,115.36147 h 261.497 l 43.104,166.668 5.051,-5.051 c 2.213,-2.213 3.094,-5.429 2.317,-8.461 l -20.187,-78.802 -19.733,-77.034 c -1.004,-3.919 -4.535,-6.66 -8.581,-6.66 z",
    fill: "#ffffff",
    id: "path40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 5.738,115.36547 h 252.321 c 2.019,0 3.782,1.366 4.287,3.32 l 41.118,158.987",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 263.225,105.32247 -250.231,0.689 c -2.341,0.006 -4.584,0.939 -6.239,2.594 l -3.175,3.176 c -2.218,2.218 -3.098,5.444 -2.312,8.481 l 40.122,155.127 c 1.011,3.909 4.538,6.64 8.576,6.64 h 250.966 c 2.349,0 4.602,-0.933 6.264,-2.595 l 2.455,-2.455 c 2.213,-2.213 3.094,-5.431 2.317,-8.463 l -40.138,-156.536 c -1.007,-3.927 -4.551,-6.669 -8.605,-6.658 z",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 125.617,239.53347 c 0.445,-2.033 2.245,-3.483 4.327,-3.483 h 34.037 c 2.827,0 4.93,2.613 4.326,5.375 l -16.851,77.086 H 179 c 3.313,0 6,2.686 6,6 v 3.5 l -35.518,-0.469 h -38.135 c -2.553,0 -4.453,-2.36 -3.907,-4.854 z",
    fill: "#dadfeb",
    id: "path43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 123.185,249.79347 c 0.589,-2.771 3.036,-4.752 5.868,-4.752 h 23.371 c 2.608,0 4.518,2.454 3.878,4.982 l -19.229,75.958 c -0.337,1.331 -1.535,2.263 -2.908,2.263 h -21.49 c -3.18,0 -5.552,-2.929 -4.89,-6.04 z",
    fill: "#e6eaf5",
    id: "path44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m 149.482,323.24547 18.597,-81.077 c 0.718,-3.132 -1.661,-6.118 -4.873,-6.118 h -32.798 c -2.352,0 -4.386,1.639 -4.886,3.937 l -17.825,81.955 c -0.678,3.117 1.696,6.063 4.886,6.063 h 36.899 34.361 c 0.553,0 1,-0.448 1,-1 v -3.26 c 0,-2.761 -2.238,-5 -5,-5 h -27.5",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m 400.844,324.30347 c 0,-2.761 -2.239,-5 -5,-5 h -131 c -2.762,0 -5,2.239 -5,5 v 3 c 0,0.552 0.447,1 1,1 h 139 c 0.552,0 1,-0.448 1,-1 z",
    fill: "#e6eaf5",
    id: "path46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m 400.844,324.30347 c 0,-2.761 -2.239,-5 -5,-5 h -131 c -2.762,0 -5,2.239 -5,5 v 3 c 0,0.552 0.447,1 1,1 h 139 c 0.552,0 1,-0.448 1,-1 z",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path47"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 531,328.26847 H 17",
    stroke: "#222638",
    strokeWidth: 1.5,
    id: "path48"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 70,
    rx: 16,
    transform: "scale(-1,1)",
    fill: "#006ef5",
    id: "rect48",
    x: -184,
    y: 5.2684679
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m 134.745,84.711468 c 1.595,2.233 4.915,2.233 6.51,0 l 6.745,-9.443 h -20 z",
    fill: "#006ef5",
    id: "path49"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 155.141,47.193468 c 0.712,0.29 1.064,1.1 0.734,1.794 -3.038,6.405 -9.422,10.816 -16.805,10.816 -10.325,0 -18.695,-8.627 -18.695,-19.268 0,-10.641 8.37,-19.267 18.695,-19.267 7.375,0 13.752,4.4 16.794,10.792 0.326,0.685 -0.011,1.487 -0.707,1.788 l -1.722,0.744 c -0.732,0.316 -1.575,-0.043 -1.937,-0.754 -2.343,-4.609 -7.029,-7.754 -12.428,-7.754 -7.744,0 -14.021,6.47 -14.021,14.451 0,7.981 6.277,14.45 14.021,14.45 5.394,0 10.077,-3.139 12.422,-7.741 0.356,-0.698 1.178,-1.058 1.904,-0.762 z",
    fill: "#ffffff",
    id: "path50"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 147.891,44.237468 c 0.714,0.291 1.069,1.107 0.7,1.784 -1.866,3.433 -5.43,5.753 -9.519,5.753 -6.023,0 -10.906,-5.032 -10.906,-11.239 0,-6.208 4.883,-11.24 10.906,-11.24 4.142,0 7.745,2.381 9.591,5.886 0.351,0.667 0.01,1.464 -0.682,1.763 l -1.706,0.738 c -0.743,0.321 -1.592,-0.062 -2.036,-0.738 -1.119,-1.709 -3.016,-2.832 -5.167,-2.832 -3.442,0 -6.232,2.875 -6.232,6.422 0,3.547 2.79,6.423 6.232,6.423 2.104,0 3.965,-1.076 5.094,-2.723 0.44,-0.643 1.252,-1.004 1.974,-0.71 z",
    fill: "#ffffff",
    id: "path51"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_215_7098",
    maskUnits: "userSpaceOnUse",
    x: 304,
    y: -103,
    width: 241,
    height: 361
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 544.846,137.76 c 0,66.262 -53.716,119.978 -119.978,119.978 -66.261,0 -119.977,-53.716 -119.977,-119.978 0,-66.2614 53.716,-240.502 119.977,-240.502 66.262,0 119.978,174.2406 119.978,240.502 z",
    fill: "#ebf5ff",
    id: "path52"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1_215_7098",
    maskUnits: "userSpaceOnUse",
    x: 683,
    y: 124,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.649099,
    height: 23.649099,
    rx: 0.84460998,
    transform: "matrix(-1,0,0,1,707,124.176)",
    fill: "#8255ff",
    id: "rect156",
    x: 0,
    y: 0
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs169"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_7098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 268,
    height: 353,
    fill: "#ffffff",
    transform: "translate(505.844,306.293)",
    id: "rect169",
    x: 0,
    y: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileMarkerHeroComputer);
export default __webpack_public_path__ + "static/media/mile-marker-hero-computer.08bafca36ef328323b4c0a1eb5001941.svg";
export { ForwardRef as ReactComponent };